import { EmailConfirmationModalData } from 'src/components/Modal/EmailConfirmationModal';
import { OkModalData } from 'src/components/Modal/OkModal';
import { YesNoModalData } from 'src/components/Modal/YesNoModal';
import { ContentModalData } from 'src/components/Modal/ContentModal';

export const modalTypes = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
};

export type IModalState = Readonly<{
  isVisible: boolean;
  startClosing: boolean;
  type: string;
  data: OkModalData & YesNoModalData & EmailConfirmationModalData & ContentModalData;
}>;
